import PropTypes from 'prop-types';
import React from 'react';

const TextGroup = props => {
  const {id, name, onChange, value} = props;
  const className = (props.error.status) ? 'control__input error' : 'control__input';
  return (
    <input
      className={className}
      id={id}
      name={name}
      onChange={onChange}
      placeholder='$'
      required
      type='text'
      value={value}
    />
  );
};

TextGroup.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
    status: PropTypes.bool
  }),
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string
};

export default TextGroup;
